'use es6';

import { Record } from 'immutable';
import { BudgetTypes } from 'AdsUI/lib/Constants';
export const GoogleBiddingStrategyTypes = {
  UNSPECIFIED: 'UNSPECIFIED',
  UNKNOWN: 'UNKNOWN',
  COMMISSION: 'COMMISSION',
  ENHANCED_CPC: 'ENHANCED_CPC',
  MANUAL_CPC: 'MANUAL_CPC',
  MANUAL_CPM: 'MANUAL_CPM',
  MANUAL_CPV: 'MANUAL_CPV',
  MAXIMIZE_CONVERSIONS: 'MAXIMIZE_CONVERSIONS',
  MAXIMIZE_CONVERSION_VALUE: 'MAXIMIZE_CONVERSION_VALUE',
  PAGE_ONE_PROMOTED: 'PAGE_ONE_PROMOTED',
  PERCENT_CPC: 'PERCENT_CPC',
  TARGET_CPA: 'TARGET_CPA',
  TARGET_CPM: 'TARGET_CPM',
  TARGET_IMPRESSION_SHARE: 'TARGET_IMPRESSION_SHARE',
  TARGET_OUTRANK_SHARE: 'TARGET_OUTRANK_SHARE',
  TARGET_ROAS: 'TARGET_ROAS',
  TARGET_SPEND: 'TARGET_SPEND'
};
const BudgetRecord = Record({
  type: BudgetTypes.DAILY,
  value: null,
  budgetId: null,
  biddingStrategy: null,

  getRequestData() {
    return {
      type: this.type,
      amount: this.value
    };
  }

});
export const fromNetwork = ({
  amount,
  type,
  budgetId
} = {}) => {
  if (!amount) {
    return null;
  }

  return BudgetRecord({
    type,
    value: amount,
    budgetId
  });
};
export default BudgetRecord;